export const DEFAULT_API_KEY_HEADER = "X-Webhook-Key";

export const FALLBACK_EVENT_TYPES = ["product.created", "product.updated", "product.deleted"];

export type WebhookDeliveryStatus = "Pending" | "Succeeded" | "Failed";

export type WebhookSubscription = {
  id: number;
  name: string;
  url: string;
  apiKey: string;
  apiKeyHeaderName: string;
  eventTypes: string[];
  isActive: boolean;
  consecutiveFailureCount: number;
  disabledAt: string | null;
  disabledReason: string | null;
  lastDeliveredAt: string | null;
  pendingDeliveryCount: number;
  failedDeliveryCount: number;
  createdAt: string;
  modifiedAt: string;
};

export type WebhookSubscriptionRequest = {
  name: string;
  url: string;
  apiKeyHeaderName: string | null;
  eventTypes: string[];
};

export type WebhookFormValues = {
  name: string;
  url: string;
  apiKeyHeaderName: string;
  eventTypes: string[];
};

export type WebhookTestResult = {
  deliveryId: number;
  success: boolean;
  statusCode: number | null;
  durationMs: number;
  responseBody: string | null;
  error: string | null;
};

export type WebhookDeliveryListItem = {
  id: number;
  webhookSubscriptionId: number;
  eventId: string;
  eventType: string;
  entityId: number | null;
  status: WebhookDeliveryStatus | string;
  attemptCount: number;
  nextAttemptAt: string | null;
  lastAttemptAt: string | null;
  deliveredAt: string | null;
  lastStatusCode: number | null;
  lastError: string | null;
  createdAt: string;
};

export type WebhookDeliveryAttempt = {
  id: number;
  attemptNumber: number;
  attemptedAt: string;
  statusCode: number | null;
  durationMs: number;
  responseBody: string | null;
  error: string | null;
};

export type WebhookDeliveryDetail = WebhookDeliveryListItem & {
  payload: string;
  attempts: WebhookDeliveryAttempt[];
};

export type WebhookDeliveryPage = {
  data: WebhookDeliveryListItem[];
  total: number;
};

export type WebhookDeliveryQuery = {
  page: number;
  pageSize: number;
  status?: WebhookDeliveryStatus;
  eventType?: string;
};
